<template>
  <div class="content">
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-4 col-12">
        </div>
        <div class="col-md-4 col-12">
          <br><br><br>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <img src="@/assets/img/logo.png" alt="">
              <hr>
              <label for="email">Escriba el email con el que está registrad@:</label>
              <input type="text" v-model="email" name="email" class="form-control"
                     :class="{ 'is-invalid': isEmail }"/>
            </div>
            <div class="form-group">
              <button class="btn btn-primary" :disabled="!ValidatePassword">Enviar email con enlace para cambiar la
                contraseña
              </button>
              <br><br>
              <p>{{ mensaje }}</p>
            </div>
          </form>
        </div>
        <div class="col-md-4 col-12">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import {userService} from '@/src/../_services';

export default {
  data() {
    return {
      email: '',
      isEmail: false,
      mensaje: ''
    }
  },
  computed: {
    ValidatePassword() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
    }
  },
  methods: {
    async handleSubmit(e) {
      var request = await userService.requestPasswordReset(this.email)
      this.mensaje = request.respuesta
    }
  }
};
</script>

<style>
.form-control {
  background-color: #c3dfff !important;
}

.btn-primary {
  background-color: #d0212d !important;
  border-color: #d0212d !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}

.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #d0212d !important;
  border-color: #d0212d !important;
}

</style>
